module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/qleg8-ab119c31e10da8496bf18ff11f117d2e.jpg";